Object.defineProperty(exports,"__esModule",{value:true});exports.attachId=undefined;var _uniqueId2=require("lodash/uniqueId");var _uniqueId3=_interopRequireDefault(_uniqueId2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var attachId=exports.attachId=function attachId(func){
return function(){return{
mutations:func.apply(undefined,arguments),
id:(0,_uniqueId3.default)("throttledEvent")};};

};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/helpers/event-handlers.js
// module id = 241
// module chunks = 0